import { useSelector } from 'react-redux';
import styles from './Product.module.css';
import selected from './assets/selected.svg';
import block from './assets/block.png';

const toSentenceCase = (str) => str ? str.toLowerCase() : '';

export default function Product({ focus, product, size, onSelect, isActive }) {
    const activeProductMenuTab = useSelector(state => state.visualizer.activeProductMenuTab);
    return (
        <li
            className={`${styles.product} ${isActive ? styles.active+' selectedProduct' : ''}`}
            data-id={product.id}
            onClick={() => {
                onSelect(product);
            }}
        >
                 {activeProductMenuTab == 'wall color' ? (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                style={{
                                    backgroundColor: product.specifier.replace("COLOR(", "").replace(")", "")
                                }}
                                src={block}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{toSentenceCase(product.name)}</div>
                        </div>
                    </>
                ) : product.categoryName === 'LVT' ? (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}&csize=${size}`}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{toSentenceCase(product.color)}</div>
                            <div className={styles.description}>{product.name}</div>
                        </div>
                    </>
                ) : product.categoryName === 'Sheet Vinyl' ? (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}&csize=${size}`}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{toSentenceCase(product.color)}</div>
                            <div className={styles.description}>{product.name}</div>
                            <div className={styles.description}>{product.seriesName.includes('Homogeneous')? 'Homogeneous' : 'Heterogeneous'}</div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.imgWrapper}>
                            <img
                                loading="lazy"
                                src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=${product.specifier}&type=prod&extra=(focus=${focus})&Size=${size}&csize=${size}`}
                                alt={`Product - ${product.id}`}
                            />
                             <div className={styles.activeContent}>
                                <img src={selected} className={styles.selectedImg} width="96" height="69" />
                            </div>
                        </div>
                        <div className={styles.productInfo}>
                            <div className={styles.title}>{toSentenceCase(product.color)}</div>
                            <div className={styles.description}>{product.manufacturerSeriesName}</div>
                            <div className={styles.description}>{product.style}</div>
                        </div>
                    </>
                )}
                     
        </li>
    );
}
